<template>
  <div>
    <!-- <shop-head currentPageName="LOGIN"></shop-head> -->
    <!-- 面包屑 -->
    <!-- <breadcrumb pageName="登录"></breadcrumb> -->
    <div style="width: 100%; background-color: #fff;">
      <div
        style="width: 339px; height: 239px; position: absolute; cursor: pointer"
        @click="
          () => {
            this.$router.push({
              path: '/home',
            });
          }
        "
      ></div>
      <img
        class="head-bg"
        v-if="la == 'zh'"
        src="../../assets/images/head-bg.png"
        alt=""
        style=""
      />
      <img
        class="head-bg"
        v-else
        src="../../assets/images/head-bg-en.png"
        alt=""
        style=""
      />
    </div>
    <div class="login-box">
      <img class="login-bg" src="../../assets/images/login-bg.png" alt="" />
      <el-row type="flex" justify="center">
        <el-col :md="12">
          <div class="login-form">
            <div class="login-title">{{ $t("广园汇汽配港登录") }}</div>
            <el-form
              ref="form"
              class="form"
              :model="form"
              :rules="rules"
              label-position="top"
            >
              <el-form-item prop="phone">
                <el-input
                  v-model="form.phone"
                  prefix-icon="el-icon-user"
                  :placeholder="$t('登录名/手机号/电子邮箱')"
                ></el-input>
              </el-form-item>
              <el-form-item prop="password">
                <el-input
                  v-model="form.password"
                  prefix-icon="el-icon-lock"
                  type="password"
                  :placeholder="$t('密码')"
                ></el-input>
              </el-form-item>
              <el-row>
                <el-col :span="12">
                  <el-checkbox v-model="isRemember">{{
                    $t("记住账号")
                  }}</el-checkbox>
                </el-col>
                <el-col :span="12" class="forget-text">
                  <span @click="gotoResetPassword">{{ $t("找回密码") }}</span>
                </el-col>
              </el-row>
              <el-button
                :dark="true"
                type="primary"
                @click="gotoIndex"
                class="login-btn"
                >{{ $t("登录") }}</el-button
              >
              <el-button
                type="text"
                @click="
                  () => {
                    this.$router.push({
                      path: '/register',
                    });
                  }
                "
                >{{ $t("没有账号,立即注册") }}</el-button
              >
              <!-- <div @click="gotoIndex" type="primary" class="login-btn">登录</div> -->
            </el-form>
          </div>
        </el-col>
      </el-row>
    </div>
    <common-footer></common-footer>
  </div>
</template>

<script>
import shopHead from "../../components/shop/head";
import commonFooter from "../../components/common/footer";
import breadcrumb from "../../components/common/breadcrumb";
import { mapState, mapMutations } from "vuex";
import { login } from "../../apis/user";
export default {
  components: {
    shopHead,
    commonFooter,
    breadcrumb,
  },
  computed: {
    // 使用 mapState 来映射 state 中的 user 信息
    ...mapState({
      user: (state) => state.user,
    }),
  },
  data() {
    return {
      isRemember: false,
      la: "",
      form: {
        phone: "",
        password: "",
        phoneCode: "",
      },
      rules: {
        phone: [{ required: true, message: " ", trigger: "blur" }],
        password: [{ required: true, message: " ", trigger: "blur" }],
      },
    };
  },
  created() {
    this.la = this.$cookie.get("language") || "zh";
  },
  methods: {
    /** 忘记密码 */
    gotoResetPassword() {
      this.$router.push({
        path: "/resetPassword",
      });
    },
    /** 跳转到主页 */
    gotoIndex() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          const data = this.form;
          delete data.phoneCode;
          login(data)
            .then((res) => {
              if (res.code == 200) {
                this.$store.commit("setUser", res.data);

                // 登录token
                localStorage.removeItem("token");
                localStorage.setItem("token", res.data.token.accessToken);

                this.$router.push({ path: "/home" }).then(() => {
                  window.location.reload();
                });
              }
            })
            .catch((e) => {
              this.$message({
                message: e.message,
                type: "error",
              });
            });
          // this.$router.push({
          //   path: '/home'
          // })
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.login-box {
  height: 477px;

  // padding: 60px 15px;
  .login-bg {
    width: 100%;
    position: absolute;
    height: 500px;
    object-fit: fill;
    left: 0px;
    margin-bottom: 20px;
  }

  .login-form {
    position: absolute;
    left: 63%;
    width: 460px;
    // height: 360px;
    margin-top: 63px;
    background-color: #ffffff;
    padding: 20px;
    box-shadow: 1px 1px 5px 5px rgb(0, 0, 0, 0.1);

    .form {
      height: 300px;
      display: flex;
      flex-direction: column;
      justify-content: space-around;
    }

    .login-title {
      font-size: 20px;
      line-height: 23px;
      text-transform: capitalize;
      font-weight: 700;
      margin-bottom: 0;
      padding-bottom: 20px;
    }

    ::v-deep .el-form-item {
      margin-bottom: 15px;
    }

    ::v-deep .el-form-item__label {
      font-weight: bold;
      line-height: 24px;
      margin-bottom: 12px;
      padding-bottom: 0;
    }

    ::v-deep .el-input__inner {
      border-radius: 0;

      &:focus {
        border-color: #409eff;
      }
    }

    ::v-deep .el-checkbox__input {
      &.is-checked {
        & + .el-checkbox__label {
          color: #409eff;
        }

        .el-checkbox__inner {
          border-color: #409eff;
          background-color: #409eff;
        }
      }

      &.is-focus {
        .el-checkbox__inner {
          border-color: #409eff;
        }
      }
    }

    ::v-deep .el-checkbox__inner {
      &:hover {
        border-color: #409eff;
      }
    }

    ::v-deep .el-checkbox__label {
      font-weight: 400;
      color: #888888;
    }
  }

  .forget-text {
    text-align: left;
    // font-weight: 600;
    cursor: pointer;

    &:hover {
      color: #409eff;
    }
  }

  .login-btn {
    width: 100%;
  }
}
</style>